import Model from '@/models/Model.js';

export default class Icon extends Model {
    static entity = 'icons';

    static fields() {
        return {
            id: this.attr(null),
            key: this.string(''),
            hex: this.string(''),
            prefix: this.string(''),
            pack: this.string(''),
            pack_class: this.string(''),

            created_at: this.string(''),
            updated_at: this.string(''),
        };
    }
}
